<xena-modal label="NemHandel" i18n-label="@@NemHandel_Modal_Label" class="modal-overview" [open]="open">
  <div i18n="@@NemHandel_RegisterYourFiscal">Register fiscal in NemHandelsRegistret</div>
  <xena-list>
    <xena-list-item>
      <h4>{{ name }}</h4>
      <p i18n="@@NemHandel_OrgNumber">OrgNumber: {{ orgNumber }}</p>
      <xena-button slot="suffix" (click)="register()" type="primary" i18n="@@NemHandel_Register_Button" [loading]="loading" *ngIf="!success">Register</xena-button>
    </xena-list-item>
  </xena-list>
  <xena-alert type="success" [open]="success">
    <xena-icon slot="icon" name="fas-check-circle"></xena-icon>
    <span i18n="@@NemHandel_RegistrationCompleted">Registration completed</span>
  </xena-alert>
  <xena-button slot="footer" (click)="close()" mode="ghost" i18n="@@NemHandel_Close_Button">Close</xena-button>
</xena-modal>
